import React, { useEffect } from 'react';
import {
	useAjax,
	XhrStatus
} from '@bosch/bt-ui';

import { useTimer } from 'react-timer-hook';
import { useNavigate } from 'react-router-dom';
import './CSRTimer.css';

// https://www.npmjs.com/package/react-timer-hook
const CSRTimer = (props) => {
	const { ComposedClass, token, isLoggedIn, ipAddress, csrInfo, updateCSRInfo } = props
	// Set to 1 minute timer
	const initTime = new Date();
	initTime.setSeconds(initTime.getSeconds() + 60);
	
	const navigate = useNavigate();
	const [returnResult, status, runAjaxInner, response] = useAjax(XhrStatus.Initial);

	const handleOnExpire = () => {
		if (isLoggedIn()) {
			if (csrInfo[ipAddress].csrStatus === 'Running') {
				const headers = {
					'Authorization': 'Bearer ' + token.token
				}

				runAjaxInner('GET', SUPPORTCONSOLE_API_URL + '/api/csrmanagement/v1/csrs/' + encodeURIComponent(ipAddress) + '/status', null, undefined, headers);

				console.log('Next check:' + new Date((new Date()).setSeconds((new Date()).getSeconds() + 60)))
			}
		}
		else {
			navigate('/');
		}
	}

	useEffect(
		() => {
			if (returnResult) {
				console.log(returnResult);
				if (returnResult.status === 'Success') {
					// Update table row information
					updateCSRInfo({ipAddress:ipAddress, updateInfo:{fieldName:'description', value:returnResult.data.description}})
					updateCSRInfo({ipAddress:ipAddress, updateInfo:{fieldName:'name', value:returnResult.data.name}})
					updateCSRInfo({ipAddress:ipAddress, updateInfo:{fieldName:'releaseVersion', value:returnResult.data.releaseVersion}})
					updateCSRInfo({ipAddress:ipAddress, updateInfo:{fieldName:'oldReleaseVersion', value:returnResult.data.releaseVersion}})
				}
				// Report the process status
				updateCSRInfo({ipAddress:ipAddress, updateInfo:{fieldName:'csrStatus', value:returnResult.data.csrStatus}})
			}
		},
		[returnResult, ipAddress, updateCSRInfo]
	);

	const {
		seconds,
		minutes,
		hours,
		days,
		isRunning,
		start,
		pause,
		resume,
		restart,
	} = useTimer({ expiryTimestamp: initTime, onExpire: handleOnExpire });

	return (
		<div>
			{ComposedClass}
			{isRunning ? null : restart(new Date((new Date()).setSeconds((new Date()).getSeconds() + 60)))}
		</div>
	);
}

export default CSRTimer;